import { useState } from "react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export const PAY_MODES = ["Cash", "UPI", "Card", "Cheque", "Bank Transfer", "SmartFleet"];

export function PaymentEditDialog({ payment, onClose, onSaved }) {
  const [f, setF] = useState(() => ({ amount: String(payment.amount), mode: payment.mode, date: payment.date, ref: payment.mode_details?.Ref || "", remarks: payment.remarks || "" }));
  const save = async () => {
    try {
      await api.patch(`/credit/payments/${payment.id}`, { amount: Number(f.amount), mode: f.mode, date: f.date, mode_details: f.ref ? { Ref: f.ref } : {}, remarks: f.remarks || null });
      toast.success("Receipt updated"); onSaved(); onClose();
    } catch (e) { toast.error(formatError(e)); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="receipt-edit-dialog">
        <DialogHeader><DialogTitle>Edit receipt {payment.receipt_number} · {payment.customer_name}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div><Label className="text-xs">Date</Label><Input type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} className="h-10 rounded-xl mt-1" data-testid="edit-rcpt-date" /></div>
          <div><Label className="text-xs">Amount ₹</Label><Input type="number" step="0.01" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} className="h-10 rounded-xl mt-1 font-mono-num" data-testid="edit-rcpt-amount" /></div>
          <div><Label className="text-xs">Mode</Label><select value={f.mode} onChange={(e) => setF({ ...f, mode: e.target.value })} className="h-10 w-full rounded-xl border border-slate-200 px-2 mt-1 bg-white" data-testid="edit-rcpt-mode">{PAY_MODES.map((m) => <option key={m}>{m}</option>)}</select></div>
          <div><Label className="text-xs">Ref</Label><Input value={f.ref} onChange={(e) => setF({ ...f, ref: e.target.value })} className="h-10 rounded-xl mt-1" /></div>
          <div className="col-span-2"><Label className="text-xs">Remarks</Label><Input value={f.remarks} onChange={(e) => setF({ ...f, remarks: e.target.value })} className="h-10 rounded-xl mt-1" /></div>
        </div>
        <DialogFooter><Button variant="outline" className="rounded-xl" onClick={onClose}>Cancel</Button><Button className="rounded-xl bg-emerald-600 hover:bg-emerald-700" onClick={save} disabled={!f.amount} data-testid="edit-rcpt-save">Save changes</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
